export default __webpack_public_path__ + "static/media/uni-wei.9242145c.svg";